import LoanInformationContainer from './LoanInformation.container';

export default LoanInformationContainer;
